/**
 * Super Admin Configuration Constants
 *
 * This file contains the centralized list of super admin email addresses.
 * Super admins have elevated privileges to manage purchased feature flags
 * across all boards.
 *
 * ## To Add a New Super Admin:
 * 1. Add their email (lowercase) to the SUPER_ADMIN_EMAILS array below
 * 2. Update firestore.rules isSuperAdmin() function with the same email
 *
 * @see firestore.rules - isSuperAdmin() function
 * @see docs/stories/4.1.board-configuration-schema-extension-migration.md
 */

/**
 * List of super admin email addresses (lowercase).
 * These emails have access to super admin features including:
 * - Board management UI for all boards
 * - Ability to modify purchased feature flags
 * - Read access to all boards regardless of membership
 */
export const SUPER_ADMIN_EMAILS: readonly string[] = [
  'kjjuno@gmail.com',
  'sawtunes@gmail.com'
] as const;

/**
 * Check if an email address belongs to a super admin.
 *
 * @param email - The email address to check (case-insensitive)
 * @returns true if the email is in the super admin list, false otherwise
 *
 * @example
 * ```typescript
 * if (isSuperAdmin(user.email)) {
 *   // Grant super admin access
 * }
 * ```
 */
export function isSuperAdmin(email: string | null | undefined): boolean {
  if (!email) {
    return false;
  }
  return SUPER_ADMIN_EMAILS.includes(email.toLowerCase());
}
